import React from 'react';
import styled from '@emotion/styled';
import Flag, { FlagGroup } from '@atlaskit/flag';
import { gridSize } from '@atlaskit/theme';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';
import { useIntl } from 'react-intl';
import { Flag as FlagType } from '../types';
import { dismissFlag } from '../actions/flag-actions';
import { useAppDispatch, useAppSelector } from '../stores/redux.store';

// We need to wrap the flag in a div to apply responsive styles so
// the flag are always visible on smaller viewports.
const ResponsiveFlagWrapper = styled.div`
  [role='alert'] {
    max-width: calc(100vw - ${gridSize() * 11}px);
  }
`;

export const FlagComponent = () => {
  const { formatMessage } = useIntl();
  const flags = useAppSelector(state => state.flags.flags);
  const dispatch = useAppDispatch();

  const toFlagComponent = (flag: FlagType) => {
    const icon =
      flag.type === 'success' ? (
        <StatusSuccessIcon
          label={formatMessage({
            id: 'flag.icon.success.label',
            defaultMessage: 'Success',
            description: 'Accessible label for the success status icon in flag notifications',
          })}
          color={token('color.icon.success')}
        />
      ) : (
        <StatusErrorIcon
          label={formatMessage({
            id: 'flag.icon.error.label',
            defaultMessage: 'Error',
            description: 'Accessible label for the error status icon in flag notifications',
          })}
          color={token('color.icon.danger')}
        />
      );
    return (
      <ResponsiveFlagWrapper id={flag.id} key={flag.id}>
        <Flag
          id={flag.id || ''}
          title={formatMessage(flag.title)}
          description={formatMessage(flag.description)}
          icon={icon}
          onDismissed={() => dispatch(dismissFlag())}
        />
      </ResponsiveFlagWrapper>
    );
  };

  return <FlagGroup>{flags.map(toFlagComponent)}</FlagGroup>;
};

export default FlagComponent;
